<template>
  <div>
    <EspSnackbar v-model="snackbarShow" light :color="theme.espotoYellow2" :text="snackbarText"/>

    <div v-if="passwordResetMode">
        <HLFormPasswordReset @close="onClosePasswordReset"/>
    </div>
    <div v-else-if="guestLoginMode">
        <HLGuestLogin @close="onCloseGuestLogin" @next="$emit('next')"/>
    </div>
    <div v-else-if="loginMode">
      <HLFormLogin @next="$emit('next')" @change="loginMode=!loginMode" @showPasswordReset="passwordResetMode=true" @doGuestAccessLogin="guestLoginMode=true" />
    </div>
    <div v-else>
      <HLFormRegister @next="loginMode=!loginMode" @change="loginMode=!loginMode"/>
    </div>
  </div>
</template>

<script>
  import HLFormRegister from "./HLFormRegister";
  import HLFormLogin from "./HLFormLogin";
  import HLFormPasswordReset from "./HLFormPasswordReset";
  import HLGuestLogin from "./HLGuestLogin";
  import EspSnackbar from "../ui/EspSnackbar";
  import {layoutMixin} from "../../utils/layout-mixin";
  import {qrLoginMixin} from "../../utils/qrlogin-mixin";

  export default {
    mixins: [layoutMixin,qrLoginMixin],
    props:{
      login:{
        type:Boolean,
        default:false
      },
      register:{
        type:Boolean,
        default:false
      },
    },
    components:{
      HLGuestLogin,
      HLFormLogin,
      HLFormRegister,
      HLFormPasswordReset,
      EspSnackbar
    },
    watch: { 
      '$route': {
        handler: function() {
            this.checkMode();
        },
        deep: true,
        immediate: true
      }
    },

    data: () => ({
      passwordResetMode:false,
      loginMode:false,
      guestLoginMode:false,
      snackbarShow:false,
			snackbarText:'',
    }),
    computed:{
    },
    methods:{
      onCloseGuestLogin(){
        this.goBack();
        setTimeout(()=>{
          this.guestLoginMode=false;
        },100);
        
      },
      onClosePasswordReset(withNotification){
        if(withNotification){
          this.snackbarText=this.$t('forgotPwAnswer');
          this.snackbarShow=true;
        }
        this.passwordResetMode=false;
      },
      isLoginPage(){
        return (window.location && window.location.href && window.location.href.indexOf('login')>-1);
      },

      checkMode(){
        this.loginMode=this.isLoginPage() || !this.register ;
      }
    },
    mounted() {
      if(this.isGuestLogin() || this.isTeamLogin()){
        this.guestLoginMode = true;
      }
    }
  }
</script>